module.exports = __webpack_public_path__ + "static/openBusiness-e2c49be3b10c65a795f99af3d7dfdc63.jpg";